import React from 'react';

import {getSpiideoVenueLabel} from '@modules/spiideoMappings/utils/helpers';
import {Authorization} from '@appComponents/Authorization';
import {authorizationObject} from '@modules/spiideoMappings/components/Table/authorizationObject';
import {IconEdit} from '@appComponents/IconCollection';
import {getLink} from '@appComponents/Link';
import {SPIIDEO_STADIUM_MAPPING} from '@constants/resources';

export const RowRenderer = (column, row) => {
    switch (column) {
        case 'venue':
            return getSpiideoVenueLabel(row.stadium);
        case 'spiideo_scene_uuid':
            return row.spiideo_scene_uuid;
        case 'actions':
            return <Authorization authorization={authorizationObject}>
                <div className='actions-list-icon'>
                    <IconEdit
                        size='large'
                        link={getLink('spiideoMappings.venuesEdit', {id: row.id})}
                        resource={SPIIDEO_STADIUM_MAPPING}
                    />
                </div>
            </Authorization>;
        default:
            return null;
    }
};
